// Statuses where the client has authorized the charge, so signing may continue.
const AUTHORIZED_STATUSES = ['succeeded', 'processing'];

export const isPaymentAuthorized = (intent) => !!intent && AUTHORIZED_STATUSES.includes(intent.status);

// Manually entered US bank accounts must be verified with microdeposits before Stripe will debit them.
export const microdepositVerification = (intent) => {
	const nextAction = intent && intent.status === 'requires_action' ? intent.next_action : null;
	if (!nextAction || nextAction.type !== 'verify_with_microdeposits') return null;
	const details = nextAction.verify_with_microdeposits || {};
	return {
		type: details.microdeposit_type === 'amounts' ? 'amounts' : 'descriptor_code',
		hostedUrl: details.hosted_verification_url || null,
		arrivalDate: details.arrival_date ? new Date(details.arrival_date * 1000) : null,
	};
};

// The `agreement-payment.blocked-*` message key explaining why signing can't continue, or null.
export const paymentBlockedReason = (intent) => {
	if (!intent) return 'unavailable';
	if (isPaymentAuthorized(intent)) return null;
	if (microdepositVerification(intent)) return 'verify-bank-first';
	if (intent.status === 'requires_payment_method') return 'enter-payment';
	if (intent.status === 'canceled') return 'canceled';
	return 'incomplete';
};

// Accepts "0.32", "$0.32" or "32" and returns whole cents, or null when it isn't a microdeposit amount.
export const parseMicrodepositAmount = (value) => {
	const text = String(value == null ? '' : value).replace(/[$\s]/g, '');
	if (!/^(\d+|\d*\.\d{1,2})$/.test(text)) return null;
	const cents = text.includes('.') ? Math.round(Number(text) * 100) : Number(text);
	return cents > 0 && cents < 100 ? cents : null;
};
